import React, { useEffect, useState } from "react";
import "./Search_Bar.css";
import { connect } from "react-redux";
import {
  SearchCandidateMarketResponse,
  SearchCandidateMarketResponseRequested,
  SearchCandidateMarketValue,
  fetchSearchSuggestions,
  SearchSuggestions,
} from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Input, AutoComplete } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const Search_Bar = (props) => {
  const dispatch = useDispatch();
  const { Search } = Input;
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [SuggestionState, setSuggestionState] = useState(false);
  const [suggestionSlisiting, setSuggestionSlisting] = useState([]);
  const [Dimensions, setDimensions] = useState(getWindowDimensions());

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onClickSkill = (e) => {
    setSuggestionState(!SuggestionState);
    setSearch(e);

    const obj = {
      search: e,
      type: "skilllisting",
    };
    const params = { obj };
    props.searchSuggestions(params); 

    if (search?.length > 0) {
      props.searchValue(e);
    }

    
   props.searchBarcalled(true) 
    
  };
  const onChangeSearch = (e) => {
   
    setSearch(e.target.value);
    if (e.target.value.length === 0) {
      // dispatch(SearchCandidateMarketValue("params")); // action dispatched
      props.searchValue("");
    }
    e.preventDefault();

    const obj = {
      search: e.target.value,
      type: "skilllisting",
    };
    const params = { obj };
    props.searchSuggestions(params); 

    dispatch(SearchSuggestions(params));
  };

  const onEnterKey = (e) => {
    localStorage.removeItem("SelectedSkills");
    if (e.key === "Enter" && search.length > 0) {
      props.searchValue(search);
      e.preventDefault();
      setSuggestionState(!SuggestionState);


      const obj1 = {
        search: e.target?.textContent,
        type: "skilllisting",
      };
      const params1 = { obj1 };
      dispatch(SearchSuggestions(params1));
      // dispatch(SearchSuggestions(e.target.value));
      // props.searchSuggestions(search);

      
      props.searchBarcalled(true)
    }
  };

  useEffect(() => {
    // setSuggestionSlisting(props?.suggestions?.searchSuggestions?.skillsListing);
    let skilllistings = props.suggestions?.searchSuggestions?.skillsListing
    if (props.suggestions?.searchSuggestions?.skillsListing) {
    setSuggestionSlisting(
          Array.from(new Set(skilllistings.map(obj=> obj._id))).map(name =>{
            return skilllistings.find(obj=> obj._id === name)
          })
        )}
 }, [props.suggestions]);


  useEffect(() => {
    setSearch(props.value);
  }, [props.value]);

  const renderTitle2 = (title) => (
    <span className="sbar-render-title2">{title}</span>
  );
  
  const renderItem2 = (title) => ({
    value: title,
    label: (
      <div
        className="candidatemarket-sbar-render-title2"
        onClick={() => onClickSkill(title)}
      >
        <div className="inner-div">{title}</div>
      </div>
    ),
  });
  const options = [
    {
      label: renderTitle2("Skill listings"),
      options:  suggestionSlisiting 
      ? suggestionSlisiting?.map((item, index) => {
          return renderItem2(item?._id);
        })
      : null,
    },
  ];

  return (
    <div className="--Candidate-Market">
      <div className="candidatemarket">Candidate market</div>
      <div className="candidatemarketing-searchGigs">
        <AutoComplete
          style={{ width: "100%", backgroundColor: "red" }}
          popupClassName="candidatemarketing-certain-category-search-dropdown" 
          options={suggestionSlisiting.length? options : null} // && SuggestionState 
        >
          {/* <div className="searchInputDashboard"> */}
          <div className="candidatemarketing-searchGigs">
            <Input
              style={{
                width: Dimensions.width < 768 ? "98%" : Dimensions.width < 540 ? "97%": "21.5rem",
                height: "auto",
                // marginLeft: Dimensions.width > 768 ? "30px" : "10px",
                marginLeft: Dimensions.width < 768 && "14px",
                marginBottom: Dimensions.width > 768 ? "-60px" : "0px",
                marginTop: "-5px",
                borderRadius: "4px",
                backgroundColor: "#fff",
                paddingLeft: Dimensions.width > 1024 && "4px",
                paddingRight: Dimensions.width < 768 && "4px",
              }}
              bordered
              allowClear
              onTouchCancel={()=> console.log("Touch Cancel") }
              onSearch={() => props.searchValue("")}
              type="text"
              placeholder="Search skill listing title"
              onPressEnter={(e) => onEnterKey(e)}
              value={search}
              open={true}
              onChange={(e) => onChangeSearch(e)}
              onClick={() => setSuggestionState(!SuggestionState)}
              prefix={
                Dimensions.width > 768 ? (
                  <SearchOutlined
                    style={{
                      fontSize: "20px",
                      color: "gray",
                      marginRight: "5px",
                      marginLeft: "3%",
                    }}
                  />
                ) : null
              }
              // onKeyPress={(e) => onEnterKey(e)}
              // className="candidatemarket-icons"
            />
            {/* <button onClick={onSearch}>Search</button> */}
          </div>
          {/* </div> */}
        </AutoComplete>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    skillListings: state.searchCandidateMarketReducer.skillListings,
    value: state.searchCandidateMarketReducer.searchvalue,
    error: state.searchCandidateMarketReducer,
    token: state.authReducer.user?.authToken,
    suggestions: state.searchCandidateMarketReducer.searchSuggestions,
    // userProfile: state.profileReducer.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // GetGigs: (params) => {
    //   dispatch(fetchGigs(params)); // action dispatched
    // },
    // SearchValue
    SearchResponseRequested: (params) => {
      dispatch(SearchCandidateMarketResponse(params)); // action dispatched
    },
    searchResponse: (params) => {
      dispatch(SearchCandidateMarketResponseRequested(params)); // action dispatched
    },
    searchValue: (params) => {
      dispatch(SearchCandidateMarketValue(params)); // action dispatched
    },
    searchSuggestions: (params) => {
      dispatch(fetchSearchSuggestions(params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search_Bar);
